import { useCircleV4 } from "@/react/hooks/useCircleV4";

import { MemberCardWithConnectionSkeleton as MemberCardWithConnectionSkeletonCompass } from "./MemberCardWithConnectionSkeletonCompass";
import { MemberCardWithConnectionSkeleton as MemberCardWithConnectionSkeletonUiKit } from "./MemberCardWithConnectionSkeletonUiKit";

export const MemberCardWithConnectionSkeleton = () => {
  const { isCircleV4 } = useCircleV4();

  if (isCircleV4) {
    return <MemberCardWithConnectionSkeletonCompass />;
  }

  return <MemberCardWithConnectionSkeletonUiKit />;
};
